import React from "react";
import './index.css';
import LogoDropDown from "../../LogoDropDown/logoDropDown";
import WithUserForm from "../../Register/WithUserForm";

function Success() {
    return (
        <WithUserForm>
            {() => {
                return (
            <div className="success-container">
                <div className='success-header'>
                    <LogoDropDown disabled={true}/>
                </div>
                <div className="success-main">
                    Thank you for applying. <br/>
                    <br/>
                    We will review your application<br/>
                    and respond to you by email.

                </div>
                <div className='success-footer'>
                    <p
                        style={{
                            color: '#B08D57',
                            fontFamily: 'Playfair Display',
                            fontWeight: 800
                        }}
                    >
                        Beauty is in the Eye of the Employer®
                    </p>
                </div>
            </div>
        )
    }}
    </WithUserForm>
    );
}

export default Success;
